import { render } from "./IOSAppstoreFaq.vue?vue&type=template&id=6c9bc639&scoped=true"
import script from "./IOSAppstoreFaq.vue?vue&type=script&lang=js"
export * from "./IOSAppstoreFaq.vue?vue&type=script&lang=js"

import "./IOSAppstoreFaq.vue?vue&type=style&index=0&id=6c9bc639&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9bc639"]])

export default __exports__